export default "__VITE_ASSET__Du74TFA3__"